"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getChildColor(theme, props) {
  if (props.disabled) {
    return theme.colors["gray300"];
  } else if (props.isOutlined) {
    if (props.color !== "primary" && props.color !== "secondary") {
      return (0, _color.default)(props.color).darken(0.25) // darken the outlined button text a bit to give us better contrast
      .string();
    } else {
      return (0, _color.default)(theme.colors[props.color]).darken(0.25) // darken the outlined button text a bit to give us better contrast
      .string();
    }
  } else {
    return theme.colors.white;
  }
}

function getBackgroundColor(theme, props) {
  if (props.isOutlined) {
    return "transparent";
  } else if (props.disabled) {
    return theme.colors["gray100"];
  } else if (props.color !== "primary" && props.color !== "secondary") {
    return props.color;
  } else {
    return theme.colors[props.color];
  }
}

function getHoverColor(theme, props) {
  if (props.disabled && props.isOutlined) {
    // if disabled and outlined
    return "transparent";
  } else if (props.disabled) {
    // if disabled
    return theme.colors["gray100"];
  } else if ( // if outlined and not primary or secondary color
  props.isOutlined && props.color !== "primary" && props.color !== "secondary") {
    // if the background is too dark fade it instead of lighten
    if ((0, _color.default)(props.color).isDark()) {
      return (0, _color.default)(props.color).fade(0.75).string();
    }

    return (0, _color.default)(props.color).lighten(0.55).string();
  } else if ( // if not outlined and not primary or secondary color
  !props.isOutlined && props.color !== "primary" && props.color !== "secondary") {
    return (0, _color.default)(props.color).darken(0.1).string();
  } else if (props.isOutlined) {
    // if is outlined and using primary or secondary
    // if the background is too dark fade it instead of lighten
    if ((0, _color.default)(theme.colors[props.color]).isDark()) {
      return (0, _color.default)(theme.colors[props.color]).fade(0.75).string();
    }

    return (0, _color.default)(theme.colors[props.color]).lighten(0.52).string();
  } else {
    // anything else
    // if the background is too dark fade it instead of lighten
    if ((0, _color.default)(theme.colors[props.color]).isDark()) {
      return (0, _color.default)(theme.colors[props.color]).fade(0.75).string();
    }

    return (0, _color.default)(theme.colors[props.color]).darken(0.1).string();
  }
}

function getRippleColor(theme, props) {
  if (props.isOutlined && props.color !== "primary" && props.color !== "secondary") {
    return (0, _color.default)(props.color).lighten(0.45).string();
  } else if (!props.isOutlined && props.color !== "primary" && props.color !== "secondary") {
    return props.color;
  } else if (props.isOutlined) {
    return (0, _color.default)(theme.colors[props.color]).lighten(0.45).string();
  } else {
    return theme.colors[props.color];
  }
}

function getBorderColor(theme, props) {
  if (props.disabled) {
    return theme.colors["gray100"];
  } else if (props.color !== "primary" && props.color !== "secondary") {
    return props.color;
  } else {
    return theme.colors[props.color];
  }
}
/**
 * A component used to render a styled button.
 */


var Button =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ripple", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleRipple", function () {
      _this.setState(function (state) {
        return {
          rippleActive: !state.rippleActive
        };
      }, function () {
        return setTimeout(function () {
          _this.setState(function (state) {
            return {
              rippleActive: !state.rippleActive
            };
          });
        }, 401);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (e) {
      var button = e.target;
      var onClick = _this.props.onClick;
      var parentOffset = button.getBoundingClientRect();
      var relX = Math.round(e.clientX - parentOffset.left);
      var relY = Math.round(e.clientY - parentOffset.top);

      if (_this.ripple) {
        _this.ripple.style.top = relY + "px";
        _this.ripple.style.left = relX + "px";
      }

      _this.toggleRipple(); // Call this.props.onClick if it exists


      if (onClick) onClick(e);
    });

    _this.state = {
      rippleActive: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          color = _this$props.color,
          Element = _this$props.element,
          icon = _this$props.icon,
          iconAlign = _this$props.iconAlign,
          innerClassName = _this$props.innerClassName,
          isOutlined = _this$props.isOutlined,
          theme = _this$props.theme,
          rest = _objectWithoutProperties(_this$props, ["children", "classes", "className", "color", "element", "icon", "iconAlign", "innerClassName", "isOutlined", "theme"]);

      var rippleActive = this.state.rippleActive;
      return (// $FlowFixMe
        _react.default.createElement(Element, _extends({
          className: (0, _classnames.default)(classes.root, className)
        }, rest, {
          onClick: this.handleClick
        }), _react.default.createElement("div", {
          className: classes.innerContainer
        }, _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.children, innerClassName)
        }, icon && iconAlign === "left" ? _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.icon, classes.iconLeft)
        }, icon) : null, children, icon && iconAlign === "right" ? _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.icon, classes.iconRight)
        }, icon) : null), _react.default.createElement("span", {
          ref: function ref(ripple) {
            return _this2.ripple = ripple;
          },
          className: (0, _classnames.default)(classes.ripple, rippleActive && classes.rippleActive)
        })))
      );
    }
  }]);

  return Button;
}(_react.Component);

_defineProperty(Button, "defaultProps", {
  color: "primary",
  element: "button",
  iconAlign: "left",
  isOutlined: false
});

var styles = function styles(theme) {
  return {
    root: {
      display: "inline-flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      textDecoration: "none !important",
      backgroundColor: function backgroundColor(props) {
        return getBackgroundColor(theme, props);
      },
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: function borderColor(props) {
        return props.isOutlined ? getBorderColor(theme, props) : "transparent";
      },
      borderRadius: theme.globalBorderRadius,
      transition: theme.transitions.default,
      overflow: "hidden",
      "&:hover": {
        backgroundColor: function backgroundColor(props) {
          return getHoverColor(theme, props);
        }
      }
    },
    innerContainer: {
      position: "relative",
      zIndex: "0"
    },
    children: {
      display: "flex",
      position: "relative",
      alignItems: "center",
      color: function color(props) {
        return getChildColor(theme, props);
      },
      fontFamily: theme.typography.sans,
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: "600",
      textDecoration: "inherit",
      padding: function padding(props) {
        return props.icon ? "8px 16px" : "10px 16px";
      },
      zIndex: "1"
    },
    icon: {
      flexShrink: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none"
    },
    iconLeft: {
      marginLeft: "-4px",
      marginRight: "6px"
    },
    iconRight: {
      marginLeft: "6px",
      marginRight: "-4px"
    },
    ripple: {
      display: "block",
      position: "absolute",
      width: "0",
      height: "0",
      borderRadius: "50%",
      transform: "translate(-50%, -50%)",
      transition: "width 0.4s ease-in-out, height 0.4s ease-in-out",
      backgroundClip: "padding-box",
      zIndex: "0",
      backgroundColor: function backgroundColor(props) {
        return getRippleColor(theme, props);
      }
    },
    rippleActive: {
      animation: "ripple .4s ease-in"
    },
    "@keyframes ripple": {
      "0%": {
        opacity: "0"
      },
      "25%": {
        opacity: "1"
      },
      "100%": {
        width: "200%",
        paddingBottom: "200%",
        opacity: "0"
      }
    }
  };
};

var _default = (0, _reactJss.default)(styles, {
  name: "EuiButton"
})(Button);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/elevate-ui/Button/index.js
// module id = 1875
// module chunks = 258017965044847